import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { JanelaApuracaoTaxaMediaMaximaAgente } from "src/app/model/janela-apuracao-taxa-media-maxima-agente";
import { FgiBackEndService } from "../fgi-back-end.service";
import { catchError } from "rxjs/operators";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
  })

export class JanelaApuracaoService extends FgiBackEndService<JanelaApuracaoTaxaMediaMaximaAgente>{
    getNewEntity(): JanelaApuracaoTaxaMediaMaximaAgente {
       return new JanelaApuracaoTaxaMediaMaximaAgente();
    }
    protected getResourceURL(): string {
        return 'front/taxa-juros-media-maxima-agente'
    }
    
    public buscarJanelasApuracao(params?: any): Observable<JanelaApuracaoTaxaMediaMaximaAgente[]> {
        return this.http.get(`${this.BASE_URL}/janelas`, {params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

    public salvarJanelaApuracao(janela: JanelaApuracaoTaxaMediaMaximaAgente): Observable<JanelaApuracaoTaxaMediaMaximaAgente>{
        const options: any = blockUi();
        return this.http.post(`${this.BASE_URL}/salvar`, janela, options).pipe
          (catchError((e) => this.handleError(e))) as Observable<any>;
    }

    public atualizarJanela(id: number, dto: JanelaApuracaoTaxaMediaMaximaAgente): Observable<any> {
        const options: any = blockUi();
        return this.http.post(`${this.BASE_URL}/${id}/atualizar`, dto, options).pipe
          (catchError((e) => this.handleError(e))) as Observable<any>;
      }
}